export default __webpack_public_path__ + "static/media/arrow-right-circle-fill.75ba9e17.svg";